import { FC } from 'react';

import { KeyTextI } from '~src/interfaces/translate.interface';

import { AddButtonWrapper } from './listAddButton.sc';

interface OwnProps {
  buttonText: KeyTextI;
  addFunc: () => void;
}

const ListAddButton: FC<OwnProps> = ({ buttonText, addFunc }) => (
  <AddButtonWrapper onClick={addFunc} data-translation={buttonText.key}>
    {buttonText.txt}
  </AddButtonWrapper>
);

export default ListAddButton;
